export default __webpack_public_path__ + "static/media/Calendar.52bfe2c8.svg";